__turbopack_context__.v({
  "banner": "OptimizelyBanner-module-scss-module__H9xbjq__banner",
  "button": "OptimizelyBanner-module-scss-module__H9xbjq__button",
  "loginButton": "OptimizelyBanner-module-scss-module__H9xbjq__loginButton",
  "subtitle": "OptimizelyBanner-module-scss-module__H9xbjq__subtitle",
  "title": "OptimizelyBanner-module-scss-module__H9xbjq__title",
});
